import React, { Component } from 'react';
import { View, Animated, ViewPropTypes, Dimensions, Platform } from 'react-native'

import propTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { PositionsProvider, TooltipsIds } from '../../../../Services/PositionsProvider';
import TrayLottie from '../trayLottie/TrayLottie';

import Styles from './TrayLottieContainer.Styles';
import { isBusinessChooser } from '../../../../../../../App/Utils';

class TrayLottieContainer extends Component {
  constructor(props) {
    super(props);
  }
  onLayout = ({ nativeEvent: { layout } }) => {
    PositionsProvider.pushPosition({
      id: TooltipsIds.TRAY,
      value: {
        width: layout.width,
        height: layout.height,
        x: layout.x,
        y:
          Dimensions.get('window').height -
          layout.height +
          PositionsProvider.getStatusBarHeight(false),
      },
    });
  };
  render() {
    const { isVisible, animation, theme, height, heightAnimation } = this.props;

    return (
      <Animated.View
        style={[Styles.containerStyle, animation]}
        pointerEvents={'none'}
        accessible={false}
        testID={FrameworkTestKeys.TrayLottieContainer}
        onLayout={this.onLayout}
      >
        <Animated.View
          style={[heightAnimation, { bottom: 3 }]}
          pointerEvents={'none'}
          accessible={false}
          testID={FrameworkTestKeys.trayLottieContainerAnimatedView}
        >
          <View testID={FrameworkTestKeys.trayLottieContainerView}>
            {isVisible && Platform.OS === 'web' ?
              <View style={{ height: 50, backgroundColor: theme.colors.tintColor, borderTopRightRadius: 8, borderTopLeftRadius: 8 }} />
              :
              <TrayLottie isVisible={isVisible} />
            }
          </View>

          <View
            style={[
              Styles.bottomStyle(theme),
              {
                //75 is the height of the visible part of the tray when it's closed (the lottie part)
                height: height - (isVisible ? isBusinessChooser() ? 20 : 60 : 85),
              },
            ]}
            testID={FrameworkTestKeys.trayLottieContainerBottomView}
          />
        </Animated.View>
      </Animated.View>
    );
  }
}

TrayLottieContainer.defaultProps = {
  theme: LightThemeColors,
};

TrayLottieContainer.propTypes = {
  isVisible: propTypes.bool.isRequired,
  theme: propTypes.object,
  animation: propTypes.object,
  heightAnimation: ViewPropTypes.style,
  height: propTypes.number,
};

export default withTheme(TrayLottieContainer);
